import { HStack, Text } from '@chakra-ui/react';
import { IconRosetteDiscountFilled, Tooltip } from '@/shared/ui';
import { useSubscribeCartStoreShallow } from '../../hooks/cartStoreHooks';
import { cartStoreSelectors } from '../../selectors';

interface CartItemPriceProps {
  itemSlug: string;
}

const CartItemPrice = ({ itemSlug }: CartItemPriceProps) => {
  const { price, discountedPrice, appliedThreshold, discountPrice } = useSubscribeCartStoreShallow(
    cartStoreSelectors.itemPriceWithDiscount(itemSlug),
  );

  const hasDiscount = discountPrice || discountedPrice < price;

  if (!hasDiscount) {
    return <Text fontWeight='bold'>${price.toFixed(2)}</Text>;
  }

  return (
    <HStack flexWrap='wrap'>
      <Text
        color='text.medium'
        fontSize='sm'
        textDecoration='line-through'
      >
        ${price.toFixed(2)}
      </Text>
      <Text fontWeight='bold'>${discountedPrice.toFixed(2)}</Text>
      {appliedThreshold?.description && (
        <Tooltip label={appliedThreshold.description}>
          {(props) => (
            <IconRosetteDiscountFilled
              _active={{ opacity: 1 }}
              _hover={{ opacity: { md: 1 } }}
              boxSize={5}
              opacity={0.3}
              {...props}
            />
          )}
        </Tooltip>
      )}
    </HStack>
  );
};

export default CartItemPrice;
